<template>
	<el-drawer title="条件退规则应用到其他演出(注意，应用之后将会覆盖这些演出的退票规则)" :visible.sync="visible" :before-close="close" size="auto"
		class="punish-box">
		<div class="drawer-content">
			<div class="page-filter-box">
				<el-row :gutter="20">
					<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
						<el-input v-model="params.searchValue" class="input-with-select" size="small" >
							<el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
								<el-option label="演出ID" :value="1"></el-option>
								<el-option label="演出名称" :value="2"></el-option>
								<el-option label="巡演ID" :value="3"></el-option>
								<el-option label="主题ID" :value="4"></el-option>
							</el-select>
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="16" :lg="12" :xl="8">
						<el-input v-model="params.bvalue" class="input-with-select" size="small">
							<el-select v-model="params.btype" slot="prepend" placeholder="请选择">
								<el-option label="项目负责人" :value="9"></el-option>
								<el-option label="上线审核人" :value="10"></el-option>
							</el-select>
						</el-input>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
						<el-select v-model="params.activityStatus" placeholder="请选择" size="small">
							<el-option label="不限制演出状态" :value="0"></el-option>
							<el-option label="仅看待审核的" :value="1"></el-option>
							<el-option label="仅看预售中的" :value="2"></el-option>
							<el-option label="仅看已结束的" :value="3"></el-option>
							<el-option label="仅看已取消的" :value="4"></el-option>
							<el-option label="仅看未通过的" :value="5"></el-option>
							<el-option label="仅看定时上架的" :value="6"></el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
						<el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
						<el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
					</el-col>
				</el-row>
			</div>
			<div class="page-list-box">
				<el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe
					@selection-change="handleSelectionChange">
					<el-table-column type="selection"></el-table-column>
					<el-table-column prop="id" label="ID"></el-table-column>
					<el-table-column prop="title" label="名称" min-width="200" show-overflow-tooltip>
						<template slot-scope="scope">
							<el-link class="ellipsis title"
								@click="$refs.H5Preview.show('/pages/activity/detail/detail?activityId=' + scope.row.id)">
								{{ scope.row.title }}
							</el-link>
						</template>
					</el-table-column>
					<el-table-column prop="performer" label="艺人阵容" min-width="120"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="beginShowTime" label="首场开演时间" min-width="150"></el-table-column>
					<!-- <el-table-column prop="cityName" label="城市"></el-table-column> -->
					<el-table-column prop="siteName" label="城市&场地" min-width="130" show-overflow-tooltip>
						<template slot-scope="{row} = scope">
							{{ row.cityName }} • {{ row.siteName }}
						</template>
					</el-table-column>
					<el-table-column prop="status" label="演出状态">
						<template slot-scope="scope">
							<span v-if="scope.row.status == 0">未提交</span>
							<span v-else-if="scope.row.status == 1" class="color-warning">待审核</span>
							<span v-else-if="scope.row.status == 2" class="color-success">预售中</span>
							<span v-else-if="scope.row.status == 3" class="color-info">已结束</span>
							<span v-else-if="scope.row.status == 4" class="color-danger">已取消</span>
							<span v-else-if="scope.row.status == 5">未通过</span>
							<el-tooltip class="item" effect="dark" :content="scope.row.onlineTime" placement="top"
								v-else-if="scope.row.status == 6">
								<span>定时上架</span>
							</el-tooltip>
						</template>
					</el-table-column>
					<el-table-column prop="startUser" label="发起人" show-overflow-tooltip></el-table-column>
					<el-table-column prop="auditorName" label="上线审核人" show-overflow-tooltip
						min-width="90"></el-table-column>
					<el-table-column prop="passAuditTime" label="审核通过时间" min-width="150"></el-table-column>
					<el-table-column prop="createTime" label="发起时间" min-width="150"></el-table-column>
				</el-table>
			</div>
			
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取 消</el-button>
			<el-button
			    type="primary"
			    @click="onSubmit"
			    :loading="btnLoading"
			    >确认</el-button
			>
		</div>
	</el-drawer>
</template>

<script>
	const defaultParams = {
		pageNo: 1,
		searchType: 1,
		searchValue: '',
		cityValue: '',
		cityType: 1,
		timeType: 1,
		beginTime: '',
		endTime: '',
		sellIdentity: 0,
		contractNo: '',
		// activityType: 0,
		activityStatus: 0,
		approval: 0,
		thirdPartner: '',
		btype: 9,
		bvalue: '',
		styleId: 0,
		// isHide: 0,
		hideType: "",
		hideTerminals: [],
		sellType: "",
		sellTerminals: [],
		balanceType: 0,
		//showTypeTagId: '',
		showTypeTagParentId: '',
		showTypeTagId: '',
		siteTypeTagId: '',
		// douyinStatus: '',
		// aliPushStatus: -1,
		//isSeat: '',
		sellMode: '',
		isDelay: '',
		thirdMiniType: '',
		thirdMiniStatus: '',
		activityChannel: "",
		alternateStatus: '',
		sortType:1
	}
	export default {
		props: {
			activityId: {
				type: [Number, String],
				default: ''
			}
		},
		components: {
		},
		data() {
			return {
				params: {
					...defaultParams,
					pageNo: parseInt(this.$route.query.pageNo || 1),
					pageSize: 50,
					searchType: parseInt(this.$route.query.searchType || 1),
					searchValue: this.$route.query.searchValue || '',
					btype: parseInt(this.$route.query.btype || 9),
					bvalue: this.$route.query.bvalue || '',
					activityStatus: parseInt(this.$route.query.activityStatus || 0)
				},
				visible: false,
				listLoading: true,
				data: null,
				dataList: null,
				activityIds: [], //选中演出ID集合
				tourId:'',
				btnLoading:false
			}
		},
		watch: {
		},
		methods: {
			show(tourId) {
				this.tourId = tourId
				if( this.tourId ){
					this.params.searchType = 3
					this.params.searchValue = this.tourId
					this.getDataList()
				}else{
					this.getDataList()
				}
				this.visible = true				
			},
			close() {
				this.visible = false
				this.data = null
				this.dataList = null
			},			
			getDataList() {

				this.listLoading = true;
				this.params = {
					...this.params
				}
				this.$request({
						url: "/activity/list",
						method: "POST",
						data: {
							...this.params
						},
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1 && result) {
							this.data = result;
							this.dataList = (result.result || []).slice(0, 50);
						} else {
							this.$message.error(msg || "请求失败");
						}
					})
					.catch(() => {
						this.$message.error("请求错误");
					})
					.finally(() => {
						this.listLoading = false;
					});
			},
			//选择pageSize
			handleSizeChange(e) {
				this.params.pageNo = 1;
				this.params.pageSize = e;
				this.getDataList();
			},
			//搜索
			search() {
				this.params.pageNo = 1;
				this.getDataList();
			},
			//重置搜索
			reset() {
				this.params = {
					...defaultParams,
					pageSize: this.params.pageSize,

				};
				this.getDataList();
			},
			//全选、反选
			handleSelectionChange(val) {
				this.activityIds = val.map(v => v.id);
			},
			onSubmit(){
				if(this.activityIds && this.activityIds.length == 0 ){
					return this.$message.warning("请先选择演出！");
				}
				this.btnLoading = true
				this.$confirm('确认应用后，这些演出的退票规则, 将按照当前演出的规则完全覆盖. 包括 乐迷端退票通道设置, 审批方设置, 退票规则设置. ', '提示', {
				    type: 'warning',
				    center: true,
				    confirmButtonText:'确认应用',
				    cancelButtonText:'取消',
				    closeOnClickModal: false,
				    showClose:false
				}).then(() => {
				    this.$request({
				    		url: "/activity/refundRule/applyToOther",
				    		method: "POST",
				    		data: {
				    			activityId: this.activityId,
								activityIds: this.activityIds
				    		},
				    	})
				    	.then((res) => {
				    		const {
				    			state,
				    			msg
				    		} = res.data;
				    		if (state == 1) {
				    			this.$message.success("操作成功");
				    			this.getDataList();
								this.btnLoading = false
								this.close()
				    		} else {
				    			this.$message.error(msg || "请求失败");
								this.btnLoading = false
				    		}
				    	})
				}).catch(() => {
					this.btnLoading = false
				    
				})
			}

		}
	}
</script>
<style lang="scss" scoped>
	::v-deep .el-drawer .drawer-content .input-with-select{
		display: inline-table;
	}
</style>